export const paypalMeBase = 'https://paypal.me/duanshufeng'
export const minimumTip = 1
export const maximumTip = 1000

export function normalizeTipAmount(value: string | number) {
  const amount = typeof value === 'number' ? value : Number(value.trim())
  if (!Number.isFinite(amount) || amount < minimumTip || amount > maximumTip) return null
  return Math.round(amount * 100) / 100
}

export function buildPayPalMeUrl(value: string | number, currency = 'USD') {
  const amount = normalizeTipAmount(value)
  if (amount === null) return null
  const formatted = Number.isInteger(amount) ? String(amount) : amount.toFixed(2).replace(/0$/,'')
  return `${paypalMeBase}/${formatted}${currency}`
}

